import { useEffect, useState } from 'react';
import { get, post } from '../../Services/api';
import './AdminIngredients.css'
import AdminIndividualIngredient from './IndividualIngredient/IndividualIngredient';
import loading_display from '../../Utility/loading_display';
import SelectedIngredientModal from './SelectedIngredientModal/SelectedIngredientModal';
import { Tooltip } from 'react-tooltip';

function AdminIngredients({ user_data }) {
    const [ingredient, setIngredient] = useState()
    const [ingredients, setIngredients] = useState()
    const [filter, setFilter] = useState('all')
    const [page, setPage] = useState(1)
    const [selectedIngredients, setSelectedIngredients] = useState([])
    const [ingredientsSelectedAction, setIngredientsSelectedAction] = useState(false)
    const [condition, setCondition] = useState('')

    useEffect(() => {
        // get ingredients
        getAllIngredients()
    }, [filter, condition, page])

    async function getAllIngredients() {
        // page number limit offset
        const offset = 10 * (page - 1)
        let response

        if (filter == 'needs attention') {
            try {
                response = await get('/api/admin/ingredient/get-ingredients-needing-review?offset=' + offset)

                if (response)
                    setIngredients(response)
                else
                    setIngredients([])
            } catch (error) {
                console.log('error getting attention needed ingredients')
            }
        } else {
            response = await post('/api/admin/ingredient/get-all-ingredients?offset=' + offset, {
                condition: condition ? condition : null
            })

            if (response)
                setIngredients(response)
            else
                setIngredients([])
        }
        if (ingredient)
            response?.map((res, i) => {
                if (res.ingredient_id == ingredient.ingredient_id)
                    setIngredient(res)
            })
    }

    function selectedIngredientFunc(ingredient_tmp, status) {
        if (status)
            // Add ingredient to array if checked and it doesn't already exist
            setSelectedIngredients((prevIngredients) => {
                const exists = prevIngredients.some((ingredient) => ingredient.ingredient_id === ingredient_tmp.ingredient_id);
                return exists ? prevIngredients : [...prevIngredients, ingredient_tmp];
            });
        else
            // Remove ingredient from array if unchecked
            setSelectedIngredients((prevIngredients) =>
                prevIngredients.filter((ingredient) => ingredient.ingredient_id !== ingredient_tmp.ingredient_id)
            );
    }

    function selectedAllIngredientFunc(status) {
        if (status)
            // Add all ingredients that don't already exist in selectedIngredients
            setSelectedIngredients((prevIngredients) => {
                const newIngredients = ingredients.filter(
                    (ingredient) => !prevIngredients.some((selectedIngredient) => selectedIngredient.ingredient_id === ingredient.ingredient_id)
                );
                return [...prevIngredients, ...newIngredients];
            });
        else
            // Remove only the ingredients that exist in the 'ingredients' array from 'selectedIngredients'
            setSelectedIngredients((prevIngredients) =>
                prevIngredients.filter(
                    (selectedIngredient) => !ingredients.some((ingredient) => ingredient.ingredient_id === selectedIngredient.ingredient_id)
                )
            );
    }

    function checkIngredientChecked(ingredient_tmp) {
        return selectedIngredients?.some((ingredient) => ingredient.ingredient_id === ingredient_tmp.ingredient_id);
    }

    function checkAllIngredientChecked() {
        return ingredients?.every((ingredient) =>
            selectedIngredients.some((selectedIngredient) => selectedIngredient.ingredient_id === ingredient.ingredient_id)
        );
    }

    async function getAllSelectedIngredients() {
        const result = await post('/api/admin/ingredient/get-all-ingredients', {
            ingredient_id_array: selectedIngredients.map((ingredient) => ingredient.ingredient_id)
        })
        if (result)
            setSelectedIngredients(result)
    }

    async function selectAllIngredientsInFilter() {
        if (filter == 'needs attention') {
            const response = await get('/api/admin/ingredient/get-ingredients-needing-review')

            if (response)
                setSelectedIngredients(response)
        } else {
            const response = await post('/api/admin/ingredient/get-all-ingredients', {
                condition: condition ? condition : null
            })
            if (response)
                setSelectedIngredients(response)
        }
    }

    function searchFunc(value) {
        if (value)
            setCondition(` AND i.name ILIKE '%${value}%'`)
        else
            setCondition()

        // reset filters because search is all inclusive
        setFilter('all')
    }

    return (
        <div className='admin_ingredients'>
            {ingredientsSelectedAction ? <SelectedIngredientModal selected_ingredients={selectedIngredients} ingredientsSelectedAction={ingredientsSelectedAction}
                setIngredientsSelectedAction={setIngredientsSelectedAction} selectedIngredientFunc={selectedIngredientFunc} checkIngredientChecked={checkIngredientChecked}
                getAllSelectedIngredients={getAllSelectedIngredients} />
                : null}

            <div className='admin_ingredients_div'>
                <div className='admin_ingredients_filter flex gap_8'>
                    <p onClick={() => setFilter('all')} className={filter == 'all' ? 'admin_ingredients_indiv_filter_selected' : 'admin_ingredients_indiv_filter'}>All</p>
                    <p onClick={() => setFilter('needs attention')} className={filter == 'needs attention' ? 'admin_ingredients_indiv_filter_attention_selected' : 'admin_ingredients_indiv_filter_attention'}>Needs Attention</p>
                </div>
                <div className='admin_ingredients_page_div text_align_center'>
                    <div className='flex gap_6 width_fit_content'>
                        {page > 1 ? <p className='font_size_16 cursor_pointer' onClick={() => setPage(page - 1)}>{'<'}</p> : null}
                        <p className='font_size_16 cursor_default'>{page}</p>
                        {ingredients && ingredients.length > 1 ? <p className='font_size_16 cursor_pointer' onClick={() => setPage(page + 1)}>{'>'}</p> : null}
                    </div>
                    <p>page</p>
                </div>

                <div className='flex gap_8'>
                    <button className='admin_ingredients_select_all_button green_gradient font_size_14 white cursor_pointer' onClick={selectAllIngredientsInFilter}>Select All</button>
                </div>

                {selectedIngredients.length ?
                    <div className='flex flex_column gap_8'>
                        <p>{selectedIngredients.length} selected</p>
                        <div className='flex gap_8'>
                            <button className='cursor_pointer' onClick={() => setIngredientsSelectedAction(true)}>Action</button>
                            <p className='admin_ingredients_unselect_all cursor_pointer' onClick={() => setSelectedIngredients([])}>Unselect</p>
                        </div>
                    </div> : null}

                <input className='add_meal_search_box font_family_inter font_size_14' placeholder='Search Ingredient...' onChange={(e) => searchFunc(e.target.value)} />

                <div className='flex gap_20 width_100'>
                    <div className={'flex flex_column ' + (!ingredient ? 'width_100' : '')}>
                        <div className={(!ingredient ? 'admin_ingredients_list_indiv_ingredient' : 'admin_ingredients_list_indiv_ingredient_small')}>
                            <input onChange={(e) => selectedAllIngredientFunc(e.target.checked)} checked={checkAllIngredientChecked()} type='checkbox' className='admin_ingredients_list_indiv_ingredient_checkbox cursor_pointer' />

                            <p className='font_size_16'>Image</p>
                            <p className='font_size_16'>Name</p>
                            {!ingredient ? <p className='font_size_16'>Restrictions</p> : null}
                            {!ingredient ? <p className='font_size_16'>Cost</p> : null}
                            {!ingredient ? <p className='font_size_16'>Unit</p> : null}
                            {!ingredient ? <p className='font_size_16'>Cal</p> : null}
                            {!ingredient ? <p className='font_size_16'>Carb</p> : null}
                            {!ingredient ? <p className='font_size_16'>Fat</p> : null}
                            {!ingredient ? <p className='font_size_16'>Protein</p> : null}
                        </div>
                        {ingredients?.map((ingredient_tmp, i) => (
                            <div key={i} className={(!ingredient ? 'admin_ingredients_list_indiv_ingredient' : 'admin_ingredients_list_indiv_ingredient_small') + ' admin_ingredients_list_indiv_ingredient_' + ((!ingredient || ingredient.ingredient_id != ingredient_tmp.ingredient_id) ? i % 2 : 'clicked')}>
                                <input onChange={(e) => selectedIngredientFunc(ingredient_tmp, e.target.checked)} checked={checkIngredientChecked(ingredient_tmp)} type='checkbox' className='admin_ingredients_list_indiv_ingredient_checkbox cursor_pointer' />

                                {ingredient_tmp.image ? <img src={ingredient_tmp.image} className='admin_ingredients_list_indiv_ingredient_img' /> : <div></div>}

                                <p className='font_size_18 font_weight_600 word_break cursor_pointer' onClick={() => setIngredient(ingredient_tmp)}>{ingredient_tmp.name}</p>

                                {!ingredient ? <p className='font_size_16 word_break'>{ingredient_tmp.restriction}</p> : null}
                                {!ingredient ? <p className='font_size_16 word_break'>${parseFloat(ingredient_tmp.cost).toFixed(2)}</p> : null}
                                {!ingredient ? <p className='font_size_16 word_break'>{ingredient_tmp.unit_name}</p> : null}
                                {!ingredient ? <p className='font_size_16 word_break'>{parseFloat(ingredient_tmp.calories).toFixed(2)}</p> : null}
                                {!ingredient ? <p className='font_size_16 word_break'>{parseFloat(ingredient_tmp.carb).toFixed(2)}</p> : null}
                                {!ingredient ? <p className='font_size_16 word_break'>{parseFloat(ingredient_tmp.fat).toFixed(2)}</p> : null}
                                {!ingredient ? <p className='font_size_16 word_break'>{parseFloat(ingredient_tmp.protein).toFixed(2)}</p> : null}


                                {!ingredient && (filter == 'needs attention') ?
                                    <div className='admin_meals_list_indiv_meal_attention_reason cursor_help white'
                                        data-tooltip-id={ingredient_tmp.ingredient_id + "-need-attention-tooltip"} data-tooltip-content={ingredient_tmp.reason}>i</div>
                                    : null}

                                <Tooltip id={ingredient_tmp.ingredient_id + "-need-attention-tooltip"} />
                            </div>
                        ))}
                    </div>

                    {ingredient ? <AdminIndividualIngredient ingredient={ingredient} setIngredient={setIngredient} getIngredient={getAllIngredients} user_data={user_data} /> : null}
                </div>
            </div>
        </div>
    );
}


export default AdminIngredients;